import { render, staticRenderFns } from "./user.vue?vue&type=template&id=65529ff9&scoped=true&"
var script = {}
import style0 from "./user.vue?vue&type=style&index=0&id=65529ff9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65529ff9",
  null
  
)

export default component.exports